module.exports = __webpack_public_path__ + "assets/ece8e25f1227accfd5bb1bb9d2277da7.png";